// Copyright (c) 2026 GLOBAL MICRO IT TECHNOLOGY SOLUTIONS LIMITED
// Company No. 758762, Dublin, Ireland
// All rights reserved. Proprietary and confidential.

import { type Configuration, LogLevel } from '@azure/msal-browser';
import { agentConfig } from '../agent-config';

// VITE_MSAL_CLIENT_ID (build-time env) overrides; agentConfig.msalClientId is
// the per-agent default so this file carries no hardcoded client-id literal.
const clientId = import.meta.env.VITE_MSAL_CLIENT_ID as string || agentConfig.msalClientId;
const authority = (import.meta.env.VITE_MSAL_AUTHORITY as string) || 'https://login.microsoftonline.com/common';
const redirectUri = (import.meta.env.VITE_MSAL_REDIRECT_URI as string) || window.location.origin;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [`api://${clientId}/access_as_user`],
};

export const apiScopes = {
  scopes: [`api://${clientId}/access_as_user`],
};
